"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ArrowBack_1 = __importDefault(require("@mui/icons-material/ArrowBack"));
const material_1 = require("@mui/material");
const react_router_dom_1 = require("react-router-dom");
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const BackButton = (props) => {
    const { location, history, baseUrl, updateStore, userLandedOn } = props;
    const goBack = () => {
        if (location.state === 'convention-checkout') {
            return history.push({
                pathname: `${baseUrl}`,
                search: location.search,
                state: null,
            });
        }
        if (location.pathname.includes('/settings')) {
            if (location.pathname.includes('/settings/language')) {
                return history.push({
                    pathname: `${baseUrl}${baseUrl !== '/' ? '/' : ''}settings`,
                    search: location.search,
                });
            }
            return history.push({
                pathname: `${baseUrl}`,
                search: location.search,
            });
        }
        if (location.pathname.includes('/notifications')) {
            if (location.pathname.includes('/notifications/detail') && window.innerWidth < 1000) {
                return history.push({
                    pathname: `${baseUrl}${baseUrl !== '/' ? '/' : ''}notifications`,
                    search: location.search,
                });
            }
            return history.push({
                pathname: `${baseUrl}`,
                search: location.search,
            });
        }
        if (baseUrl === userLandedOn) {
            return history.goBack();
        }
        history.push({
            pathname: baseUrl,
            search: location.search,
        });
        return updateStore('userLandedOn', baseUrl);
    };
    return (react_1.default.createElement(material_1.IconButton, { className: "icon-circle", sx: { mr: '1vmin' }, edge: "start", "aria-label": "back button", onClick: goBack, id: "aqa_navigation_back" },
        react_1.default.createElement(ArrowBack_1.default, { color: "colorOnAppBar" })));
};
const mapStoreToProps = store => ({
    baseUrl: store.getValue('baseUrl'),
    userLandedOn: store.getValue('userLandedOn'),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(BackButton));
